<template>
  <transition name="modal">
    <div class="modal-mask" id="error-modal">
      <div class="modal-wrapper">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title warning-orange"> ERROR {{ errorStatus }} : {{ popupError }}</h2>
            </div>
            <div class="modal-body" v-if="showButton">
              <input type="button" class="btn blue-btn btn-success btn-xs" :value="popupErrorButton" @click="close"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import store from "@/store";
import screenService from "@/services/screenApiService";
import {mapState} from "vuex";

export default {
  name: "Error",
  data() {
    return {
      popupError: 'Geen internetverbinding.\n' +
          '\n' +
          'Gelieve een systeem administrator te contacteren.',
      popupErrorButton: 'Sluiten',
      showButton: true
    }
  },
  emits: ['closeError', 'closeCardFailedError'],
  computed: mapState(['errorStatus']),
  mounted() {
    this.getTranslation(store.state.languageId, 'popupError');
    this.getTranslation(store.state.languageId, 'popupErrorButton');
  },
  methods: {
    getTranslation(lang = store.state.languageId, key) {
      let app = this;
      if (lang === null) {
        lang = store.state.defaultLanguage.id
        if (store.state.errorStatus === 401) {
          app.popupError = "Er is een probleem met de computer en deze moet opnieuw worden opgestart. \n" +
              "Gelieve een systeem administrator te contacteren."
          app.popupErrorButton = "Sluiten"
        }
        if (store.state.errorStatus.includes('BADGES_FILE')) {
          app.showButton = false;
          app.popupError = "Er is een probleem met het lezen van de badges bestand."
          app.popupErrorButton = "Sluiten"
        }

      }

      if (lang) {
        screenService.getTranslation(lang, 'fe.' + store.state.errorStatus + key).then(function (response) {
          app[key] = response.data;
        }).catch(function (er) {
          if (er.response.status === 401) {
            app.popupError = "Er is een probleem met de computer en deze moet opnieuw worden opgestart. \n" +
                "Gelieve een systeem administrator te contacteren."
            app.popupErrorButton = "Sluiten"
          } else {
            console.log("No translation found for fe." + store.state.errorStatus + key + " in language " + lang);
            console.log(er);
            app[key] = "-";
            //app.getTranslation(store.state.defaultLanguage.id, key);
          }
        })
      }
    },
    close() {
      if (this.errorStatus === "CHECK_CARD_FAILED" || this.errorStatus === "READ_CARD_FAILED") {
        this.$emit('closeCardFailedError')
      } else {
        this.$emit('closeError')
      }
    }
  }

}
</script>